import SettingBase from '../../../settings/util/SettingBase'

class EnvironmentConfigController extends SettingBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.$state = $state;
        this.id = "environment_config";
        this.acl = {};
        this.hasACL = {};
    }

    $onInit() {
        super.$onInit()
        for (let key in this.acl['tnt_control_' + this.id]) {
            this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
        }
    }
}

export default EnvironmentConfigController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/environment_config.controller.js